import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

const Field = styled(TextField)`
	width: calc(50% - 15px);
	margin-right: 30px;
	margin-bottom: 20px;

	:nth-child(2n) {
		margin-right: 0;
	}
`

const Control = styled(FormControl)`
	width: calc(50% - 15px);
	margin-right: 30px;

	&:nth-child(2n) {
		margin-right: 0;
	}
`

const NumberFields = ({currencyPosition, decimalSeparator, currencySymbol, decimalLength, handleChange, intl}) => (
    <React.Fragment>
        <Field variant="standard"
            onBlur={handleChange}
            label={intl.formatMessage({id: "config.number_field_label_decimals_number"})}
            name='decimalLength'
            defaultValue={decimalLength}
            InputLabelProps={{
                shrink: true
            }}
        />
        <Field variant="standard"
            onBlur={handleChange}
            label={intl.formatMessage({id: "config.number_field_label_currency_symbol"})}
            name='currencySymbol'
            defaultValue={currencySymbol}
            InputLabelProps={{
                shrink: true
            }}
        />
        <Control variant="standard">
            <InputLabel>{intl.formatMessage({id: "config.number_field_label_decimal_separator"})}</InputLabel>
            <Select
                value={decimalSeparator}
                onChange={handleChange}
                inputProps={{
                    name: 'decimalSeparator'
                }}
            >
                <MenuItem value='.'>{intl.formatMessage({id: "config.number_field_pointer"})} (1.234)</MenuItem>
                <MenuItem value=','>{intl.formatMessage({id: "config.number_field_comma"})} (1,234)</MenuItem>
            </Select>
        </Control>
        <Control variant="standard">
            <InputLabel>{intl.formatMessage({id: "config.number_field_currency_alignment"})}</InputLabel>
            <Select
                value={currencyPosition}
                onChange={handleChange}
                inputProps={{
                    name: 'currencyPosition'
                }}
            >
                <MenuItem value={2}>{intl.formatMessage({id: "config.number_field_right"})}</MenuItem>
                <MenuItem value={1}>{intl.formatMessage({id: "config.number_field_left"})}</MenuItem>
            </Select>
        </Control>
    </React.Fragment>
)

export default injectIntl(NumberFields)
